import React, { useState } from 'react';
import { useClient } from 'jsonapi-react';
import { BadgeTruncate } from '@/components/ui/badge';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import { PlayfulCard } from '@/components/custom/playful-card';
import { StudyGuideMatterDialog } from './study-guide-matter-dialog';

// Variante playful de StudyGuideMatterRow — mesma lógica de bloqueio/desbloqueio,
// mas em formato de card (usada no grid da study-guide-matter-data-grid.jsx quando
// usePlayfulStudent() é true) em vez de linha de tabela.
export function StudyGuideMatterCard(props) {
  const { matter } = props;

  const client = useClient();

  const [open, setOpen] = useState(false);
  const [isBlock, setIsBlock] = useState(matter.status === 'blocked');

  const taxonomyChildren = matter?.['taxonomy-children'] || [];

  const updateTaxonomyStatus = async (id, payload) => {
    try {
      await client.mutate(`user_taxonomies/${id}`, payload);
    } catch (error) {
      console.error('Failed to update taxonomy:', error);
    }
  };

  const handleConfirm = () => {
    const newStatus = isBlock ? 'active' : 'blocked';
    updateTaxonomyStatus(matter.id, { status: newStatus });
    setIsBlock(!isBlock);
    setOpen(false);
  };

  return (
    <PlayfulCard
      className="gap-3 p-4"
      style={isBlock ? { background: 'var(--color-bg-cream)' } : undefined}
      badge={matter.isAdd ? { text: 'Você adicionou', variant: 'attention' } : undefined}
    >
      <p
        className="mb-0 text-sm font-extrabold"
        style={{ color: '#222731' }}
      >
        {matter?.['taxonomy-name']}
      </p>

      <BadgeTruncate
        items={taxonomyChildren}
        oneLine
      />

      {isBlock ? (
        <button
          type="button"
          onClick={handleConfirm}
          className="mt-1 w-full rounded-full border border-[var(--color-secondary)] bg-white py-2 text-sm font-extrabold text-[var(--color-secondary)] transition-transform active:scale-[0.97]"
        >
          Desbloquear
        </button>
      ) : (
        <Dialog
          open={open}
          onOpenChange={setOpen}
        >
          <DialogTrigger asChild>
            <button
              type="button"
              className="mt-1 w-full rounded-full border border-rose-300 bg-white py-2 text-sm font-extrabold text-rose-500 transition-transform active:scale-[0.97]"
            >
              Bloquear
            </button>
          </DialogTrigger>

          <StudyGuideMatterDialog onSubmit={handleConfirm} />
        </Dialog>
      )}
    </PlayfulCard>
  );
}
